import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}
const DepartureToIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "DepartureToGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.9651 22H6.29532C4.83029 22 3.63843 20.8081 3.63843 19.3431V6.46886C3.63843 5.00384 4.83029 3.81198 6.29532 3.81198H18.9651C20.4302 3.81198 21.622 5.00384 21.622 6.46886V11.0613C21.622 11.3435 21.3937 11.5718 21.1116 11.5718C20.8294 11.5718 20.6011 11.3435 20.6011 11.0613V6.46886C20.6011 5.56662 19.8674 4.83286 18.9651 4.83286H6.29532C5.39307 4.83286 4.65931 5.56662 4.65931 6.46886V19.3431C4.65931 20.2454 5.39307 20.9791 6.29532 20.9791H18.9651C19.8674 20.9791 20.6011 20.2454 20.6011 19.3431V18.5136C20.6011 18.2315 20.8294 18.0032 21.1116 18.0032C21.3937 18.0032 21.622 18.2315 21.622 18.5136V19.3431C21.622 20.8081 20.4302 22 18.9651 22Z"
        fill="#696969"
      />
      <path
        d="M21.0622 9.71096H4.19822C3.91608 9.71096 3.68778 9.48266 3.68778 9.20052C3.68778 8.91838 3.91608 8.69008 4.19822 8.69008H21.0622C21.3444 8.69008 21.5727 8.91838 21.5727 9.20052C21.5727 9.48266 21.3444 9.71096 21.0622 9.71096Z"
        fill="#696969"
      />
      <path
        d="M16.7589 6.64432C16.4767 6.64432 16.2484 6.41602 16.2484 6.13388V2.51044C16.2484 2.2283 16.4767 2 16.7589 2C17.041 2 17.2693 2.2283 17.2693 2.51044V6.13388C17.2693 6.41602 17.041 6.64432 16.7589 6.64432Z"
        fill="#696969"
      />
      <path
        d="M8.50108 6.64432C8.21894 6.64432 7.99064 6.41602 7.99064 6.13388V2.51044C7.99064 2.2283 8.21894 2 8.50108 2C8.78322 2 9.01152 2.2283 9.01152 2.51044V6.13388C9.01152 6.41602 8.78322 6.64432 8.50108 6.64432Z"
        fill="#696969"
      />
      <path
        d="M17.1282 17.0431C16.9976 17.0431 16.867 16.9932 16.7673 16.8935C16.568 16.6941 16.568 16.3711 16.7673 16.1717L18.6247 14.3144L16.7673 12.4571C16.568 12.2577 16.568 11.9347 16.7673 11.7353C16.9667 11.5359 17.2897 11.5359 17.4891 11.7353L19.7074 13.9535C19.9067 14.1529 19.9067 14.4759 19.7074 14.6753L17.4891 16.8935C17.3894 16.9932 17.2588 17.0431 17.1282 17.0431Z"
        fill="#696969"
      />
      <path
        d="M19.3465 14.8249H12.959C12.6768 14.8249 12.4485 14.5966 12.4485 14.3144C12.4485 14.0323 12.6768 13.804 12.959 13.804H19.3465C19.6286 13.804 19.8569 14.0323 19.8569 14.3144C19.8569 14.5966 19.6286 14.8249 19.3465 14.8249Z"
        fill="#696969"
      />
    </svg>
  );
};

export default DepartureToIcon;
